import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { fileSpec, fileStatus, type FileSpec, type FileStatus } from './schema'

const Nothing = () => null

/** Files are drawn by the Files app (views/files), not by generic list rows. */
export const fileKind: ClientKind<FileSpec, FileStatus> = {
  name: 'File',
  version: 1,
  spec: fileSpec,
  status: fileStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: ['complete'],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: true,
}

export * from './schema'
export type { FileResource } from './apply'
export { nameProblem } from './apply'
